<template>
  <div>
    <singleDateForm
      v-model="date"
      :label="$t('dangerousGoods.dangerousGoodsList.form.safetyDataSheetDate')"
      prependIcon="event"
    />
  </div>
</template>
<script>
import singleDateForm from "../../_utils/general/singleDateForm.vue";

export default {
  props: ["value"],
  components: { singleDateForm },
  computed: {
    date: {
      get() {
        //the date of the sheet itself, independent of when it was uploaded
        return this.value.safetyDataSheetDate
          ? new Date(this.value.safetyDataSheetDate)
          : null;
      },
      set(val) {
        this.value.safetyDataSheetDate = val || null;
      },
    },
  },
};
</script>
